import { computed, defineComponent, reactive, watch } from "vue";
import styles from "./Menu.module.less";
import { useStore as useMenuStore } from "@/store/menu";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  props: {
    // 菜单展开
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: any) {
    const route = useRoute();
    const router = useRouter();
    const menuStore = useMenuStore();
    // 菜单列表
    const menu_list = computed(() => {
      return menuStore.menu_list || [];
    })
    const state = reactive({
      selectedKeys: [] as any[],
      openKeys: [] as any[],
    });
    // 设置打开的菜单
    const setOpenKeys = () => {
      state.openKeys = route.matched.map(x => x.name);
    }
    // 监听路由变化，对应激活菜单项
    watch(() => route, (nv, ov) => {
      if (nv?.meta?.activeMenu) {
        state.selectedKeys = [nv?.meta?.activeMenu];
      } else {
        state.selectedKeys = [nv.name];
      }
      setOpenKeys();
    }, {
      immediate: true,
      deep: true,
    });
    // 页面跳转
    const navTo = (item: { [key: string]: any }) => {
      if (item.redirect === "noRedirect") {
        return;
      }
      if (item.name === route.name) {
        return;
      }
      router.push({
        name: item.name,
      })
    }
    const MenuItemSimple: any = ({ item }: any) => {
      if(item.hidden) {
        return;
      }
      if (item.children) {
        if (item.alwaysShow) {
          return (
            <a-sub-menu key={item.name} v-slots={{
              title: () => item?.meta?.title,
              icon: () => item?.meta?.icon && <svg-icon name={item?.meta?.icon} style={{ fontSize: "14px" }} />,
            }}>
              {
                item.children.map((y: any) => <MenuItemSimple item={y} />)
              }
            </a-sub-menu>
          );
        } else {
          const node = item.children[0];
          return (
            <a-menu-item key={node.name} onClick={() => { navTo(node) }} v-slots={{
              icon: () => node?.meta?.icon && <svg-icon name={node?.meta?.icon} style={{ fontSize: "14px" }} />
            }}>
              <span title={node?.meta?.title || ''}>{node?.meta?.title || ""}</span>
            </a-menu-item>
          )
        }
      } else {
        return (
          <a-menu-item key={item.name} onClick={() => { navTo(item) }} v-slots={{
            icon: () => item?.meta?.icon && <svg-icon name={item?.meta?.icon} style={{ fontSize: "14px" }} />
          }}>
            <span title={item?.meta?.title || ''}>{item?.meta?.title || ""}</span>
          </a-menu-item>
        );
      }
    }
    return () => (
      <div class={styles.menu}>
        <a-menu
          v-model:openKeys={state.openKeys}
          v-model:selectedKeys={state.selectedKeys}
          mode="inline"
          theme="dark"
          inline-collapsed={props.isCollapsed}
        >
          {
            menu_list.value.map((item) => {
              return <MenuItemSimple item={item} />
            })
          }
        </a-menu>
      </div>
    )
  }
})